import React, { useEffect } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import { toast } from "react-toastify";

import * as actions from "../../store/actions";
import { getRole, getUserData } from "../../utils/localStorage";
import {
  PHYSICIAN_MENU,
  PATIENT_MENU,
  getOnboardingPath,
  getDashboardPath,
} from "../../constants";
import { Link, withRouter } from "react-router-dom";
import "./SideMenu.css";
import constants from "../../constants";

import defaultPic from "../../assets/onboarding/default_pic.svg";
import ImageInput from "../../components/formElements/file/ImageInput";
import VerticalStepper from "../../components/uiElements/vertical-stepper/vertical-stepper";
import Button from "../../components/formElements/button/Button";

const SideContent = ({
  logout,
  personalInfo,
  patientPersonalInfo,
  location,
  history,
  getPatientDetails,
  practiceDetails,
  documents,
  updateProfileImage,
  showBack,
  redirectedPath,
  medicalRecord,
  bankDetails,
  personalisedExperience,
  is_subscription_exists,
}) => {
  const MENU = getRole() === "PHYSICIAN" ? PHYSICIAN_MENU : PATIENT_MENU;

  const userData = getUserData();
  const userStatus = userData?.doctor_status === "ACCEPTED";

  useEffect(() => {
    if (
      getRole() === "PATIENT" &&
      !patientPersonalInfo.dataLoaded &&
      userData?.id
    ) {
      getPatientDetails();
    }
    // eslint-disable-next-line
  }, []);

  const onFileError = error => {
    toast.error(error, {
      position: constants.TOAST_POSITION,
    });
  };

  const getMenuStatus = menuId => {
    return (
      (menuId === "personalInfo" && personalInfo.dataLoaded) ||
      (menuId === "practiceDetails" && practiceDetails.dataLoaded) ||
      (menuId === "documents" && documents.dataLoaded) ||
      (menuId === "bankDetails" && bankDetails) ||
      (menuId === "dosespot" && personalInfo?.dosespot_id) ||
      (menuId === "personaliseExperience" && personalisedExperience?.is_paid) ||
      (menuId === "purchaseSubscription" && is_subscription_exists) ||
      (menuId === "uploadSignature" && personalInfo.docsignature) ||
      (menuId === "patientPersonalDetails" && patientPersonalInfo.dataLoaded) ||
      (menuId === "patientContactDetails" &&
        patientPersonalInfo.dataLoaded &&
        patientPersonalInfo?.address1) ||
      (menuId === "patientDosespotDetail" &&
        patientPersonalInfo?.dosespot_id) ||
      (menuId === "patientMedicalRecord" &&
        medicalRecord.medical_records.length)
    );
  };

  return (
    <div className="mt-3 align-items-center">
      <ImageInput
        imageData={personalInfo?.photo ? personalInfo?.photo : userData?.image}
        defaultPic={defaultPic}
        name="photo"
        label="Add Photo"
        showPreview
        onChange={files => updateProfileImage(files)}
        onError={error => onFileError(error)}
      />
      {showBack && (
        <Button
          type="corner pr-3"
          style={{
            position: "absolute",
            left: 0,
          }}
          onClick={() =>
            history.push(
              !userStatus
                ? getOnboardingPath("/under-review")
                : getDashboardPath("/appointments")
            )
          }
          label={
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrow-left ml-2"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
                />
              </svg>{" "}
              {userData?.doctor_status === "DENIED" ? "Re-approve" : "Back"}
            </>
          }
        />
      )}
      <p className="font-weight-bold mt-n3 name">
        {userData?.firstName} {userData?.lastName}
      </p>
      {MENU.map((menu, i) => (
        <div
          className={classnames(
            "progress-card mb-2",
            location.pathname === getOnboardingPath(menu.path) &&
              "current-step",
            !getMenuStatus(menu.id) && !redirectedPath && "disable"
          )}
          onClick={() => history.push(getOnboardingPath(menu.path))}
        >
          <div className="d-inline-block">
            <VerticalStepper
              hidden={i === 0}
              completed={getMenuStatus(menu.id)}
              isProfile={redirectedPath}
            />
          </div>
          <div className="d-inline-block menu-title">{menu.title}</div>
        </div>
      ))}
      {(!redirectedPath || !userStatus) && (
        <p className="mx-auto text-center">
          <Link className="logout-link" onClick={() => logout()}>
            Sign out
          </Link>
        </p>
      )}
    </div>
  );
};

const mapStoreToProps = ({ onboarding, auth }) => ({
  personalInfo: onboarding.personalInfo,
  practiceDetails: onboarding.practiceDetails,
  documents: onboarding.documents,
  redirectedPath: auth.redirectToOnboardingPath,
  patientPersonalInfo: onboarding.patientPersonalInfo,
  medicalRecord: onboarding.medicalRecord,
  bankDetails: onboarding.accountDetails?.bankDetails,
  is_subscription_exists: onboarding.accountDetails?.is_subscription_exists,
  personalisedExperience: onboarding.personalisedExperience,
  isAuth: auth.isAuth,
});

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(actions.logout()),
  getDoctorDetails: (flag, cb) => dispatch(actions.getDoctorDetails(flag, cb)),
  getPatientDetails: flag => dispatch(actions.getPatientDetails(flag)),
  updateProfileImage: updatedData =>
    dispatch(actions.updateProfileImage(updatedData)),
  getDoctorAppTheme: () => dispatch(actions.getDoctorAppTheme()),
  getUserDetailId: cb => dispatch(actions.getUserDetailIdAction(cb)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(SideContent)
);
